import type { CsvFile } from "../api/types";

/** Saves a CSV file client-side (BOM so Excel reads Arabic as UTF-8). */
export function downloadCsv(file: CsvFile): void {
  const blob = new Blob(["﻿", file.csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = file.filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
